import React, { useEffect, useState } from "react";
import {
  CardContent,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
import {
  useGetAllTeamsQuery,
  useGetAuditTicktetWiseReportQuery,
} from "../../../../Services/reports/tickets/ReportTickets";
import { toast } from "react-toastify";
import CsvDownloader from "react-csv-downloader";

const AuditTicktetReport1 = () => {
  const navigate = useNavigate();
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [params, setParams] = useState<any>(null);
  const [selectedTeams, setSelectedTeams] = useState<any>([]);
  const [selectedTeamsParam, setSelectedTeamsParam] = useState<string[]>([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [localLoading, setLocalLoading] = useState(false);
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [columns, setColumns] = useState<any>([]);
  const { data: teamsData, isLoading: teamsLoading } = useGetAllTeamsQuery({});
  const {
    data: auditTicktetWiseReport,
    isLoading: auditTicktetWiseReportLoading,
    error: auditTicktetWiseReportError,
  } = useGetAuditTicktetWiseReportQuery(params, {
    skip: !params,
  });

  const [theTeams, setTheTeams] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const handleDownloadClick = () => {
    setLoading(true);

    // Simulate the completion of the download after interaction
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust the timeout for better user experience if needed
  };
  useEffect(() => {
    // Debugging teamsData
    const teams = teamsData?.teams;
    if (Array.isArray(teams)) {
      setTheTeams(teams); // Only set if it's an array
    } else {
      setTheTeams([]); // Fallback to an empty array if it's not an array
    }
  }, [teamsData]);

  useEffect(() => {
    if (params) {
      setLocalLoading(true);
    }
  }, [params]);

  useEffect(() => {
    const dropdownHeadings = document.querySelectorAll(".dropdown-heading");
    dropdownHeadings.forEach((heading: any) => {
      heading.style.height = "50px";
    });
  }, []);
useEffect(() => {
  const isDate = (value) => {
    if (typeof value !== 'string') return false;
    
    // More flexible date patterns
    const datePatterns = [
      /^\d{4}-\d{1,2}-\d{1,2}$/,  // YYYY-M-D or YYYY-MM-DD
      /^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}(?::\d{1,2})?$/,  // YYYY-M-D H:MM:SS or variations
      /^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}(?::\d{1,2})?/,   // ISO format with flexible time
      /^\d{1,2}\/\d{1,2}\/\d{4}$/,  // D/M/YYYY or DD/MM/YYYY
      /^\d{4}\/\d{1,2}\/\d{1,2}$/   // YYYY/M/D or YYYY/MM/DD
    ];
    
    return datePatterns.some(pattern => pattern.test(value)) && !isNaN(Date.parse(value));
  };

 const formatDateTime = (value) => {
  if (!value) return "-";
  
  try {
    // Normalize the date string first
    let normalizedValue = value;
    
    // Handle single-digit hours in format "2025-3-7 8:23:54"
    if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}(?::\d{1,2})?$/.test(value)) {
      // Add leading zeros to single-digit hours, minutes, seconds
      normalizedValue = value.replace(/(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):?(\d{0,2})/, 
        (match, y, M, d, H, m, s) => {
          const pad = n => n.padStart(2, '0');
          const sec = s ? `:${pad(s)}` : '';
          return `${y}-${pad(M)}-${pad(d)} ${pad(H)}:${pad(m)}${sec}`;
        }
      );
    }
    
    const date = new Date(normalizedValue);
    if (isNaN(date.getTime())) return value; // Return original if still invalid
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    // Check if the original value was just a date (no time component)
    const isDateOnly = /^\d{4}-\d{1,2}-\d{1,2}$/.test(value.trim());
    
    if (isDateOnly) {
      return `${day}/${month}/${year}`;
    }
    
    // If it has time, include time in 24-hour format
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (e) {
    return value; // Return original if parsing fails
  }
};
  // Rest of your useEffect code remains the same...
  if (auditTicktetWiseReport?.length > 0) {
    const keys = Object.keys(auditTicktetWiseReport[0]);
    const newColumns = keys.map((key) => ({
      field: key,
      headerName: key,
      align: "center",
      headerAlign: "center",
      minWidth: 200,
    }));

    const newRows = auditTicktetWiseReport.map((row, index) => {
      const processedRow = {};
      keys.forEach((key) => {
        const value = row[key];
        
        if (value === "" || value === null || value === "-" || value === "--") {
          processedRow[key] = "-";
        } 
        else if (isDate(value)) {
          processedRow[key] = formatDateTime(value);
        } 
        else {
          processedRow[key] = value;
        }
      });
      
      return {
        id: index,
        ...processedRow,
      };
    });

    setColumns(newColumns);
    setDataRows(newRows);
  } else {
    setColumns([]);
    setDataRows([]);
  }
  setLocalLoading(false);
}, [auditTicktetWiseReport]);
  useEffect(() => {
    setLocalLoading(false);
  }, [auditTicktetWiseReportError]);

  const handleDateFromChange = (event: any) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event: any) => {
    setDateTo(event.target.value);
  };

  const handleSubmit = () => {
    const filteredTeams = selectedTeamsParam.filter((team) => team !== "all");
    if (!dateFrom) {
      toast.error('Please select "From Date"');
      return;
    }
    if (!dateTo) {
      toast.error('Please select "To Date"');
      return;
    }

    if (!filteredTeams.length) {
      toast.error('Please select "Team"');
      return;
    }

    const queryParams: any = {
      gte: dateFrom,
      lte: dateTo,
    };

    if (filteredTeams.length > 1) {
      queryParams.team_ids = filteredTeams.join(","); // Convert array to comma-separated string
    } else if (filteredTeams.length <= 1) {
      queryParams.team_id = filteredTeams;
    }

    setParams(queryParams);
  };

  const resetFilters = () => {
    setDateFrom("");
    setDateTo("");
    setParams(null);
    setSelectedTeams([]);
    setDataRows([]);
  };

  const handlePaginationChange = (newPaginationModel: any) => {
    setLocalLoading(true);
    setPaginationModel(newPaginationModel);
    setTimeout(() => {
      setLocalLoading(false);
    }, 1000);
  };

  const handleTeamsChange = (event: any) => {
    const {
      target: { value },
    } = event;

    if (value.includes("all")) {
      setSelectedTeams(
        selectedTeams.length === theTeams.length
          ? []
          : theTeams.map((team) => team.id)
      );
    } else {
      // Convert the value to an array of strings
      setSelectedTeams(typeof value === "string" ? value.split(",") : value);
    }
  };

  useEffect(() => {
    setSelectedTeamsParam(selectedTeams);
  }, [selectedTeams]);

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };
  const isAllSelected = selectedTeams.length === theTeams.length;

  return (
    <div
      id="kt_app_content_container"
      className="app-container mx-5"
      style={{ height: "100%", width: "100%", overflow: "auto" }}
    >
      <div className="card card-flush">
        <div
          className="card-header align-items-center py-1 gap-2 gap-md-5"
          style={{ justifyContent: "flex-start" }}
        >
          {/* <img
            src="https://insurance.circleonecrm.com/assets/arrow_back.svg"
            alt="Back"
            style={{ marginBottom: "-2px", cursor: "pointer" }}
            className="ng-star-inserted"
            onClick={() => {
              navigate("/reports/ticket/reports-list");
            }}
          /> */}
          <button
            className="btn btn-link mb-2"
            onClick={() => {
              navigate("/reports/ticket/reports-list");
            }}
            style={{ marginRight: "-17px" }}
          >
            <i
              className="bi bi-arrow-90deg-left"
              style={{
                fontSize: "20px",
                color: "black",
                cursor: "pointer",
              }}
            ></i>
          </button>
          <span className="fs-3 text-gray-800 fw-bold ms-3">Audit trail</span>
        </div>

        <div
          className="card-toolbar flex-row-fluid justify-content-start gap-5 d-flex mb-10"
          style={{ marginLeft: "30px" }}
        >
          <div className="w-100 mw-150px">
            <TextField
              id="date-from"
              label="From"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                  max: new Date().toISOString().split("T")[0]
                },
              }}
              fullWidth
              value={dateFrom}
              onChange={handleDateFromChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <TextField
              id="date-to"
              label="To"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                  max: new Date().toISOString().split("T")[0],
                },
              }}
              fullWidth
              value={dateTo}
              onChange={handleDateToChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Teams
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedTeams}
                onChange={handleTeamsChange}
                input={<OutlinedInput label="Select Teams" />}
                renderValue={(selected) => {
                  if (isAllSelected) {
                    return <div>All</div>;
                  }
                  return (
                    <div>
                      {selected
                        .map((teamId) => {
                          const team = theTeams.find((t) => t.id === teamId);
                          return team ? team.name : null;
                        })
                        .join(", ")}
                    </div>
                  );
                }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  onClick={() =>
                    setSelectedTeams(
                      isAllSelected ? [] : theTeams.map((team) => team.id)
                    )
                  }
                >
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={selectedTeams?.length > 0 && !isAllSelected}
                  />
                  <ListItemText primary="All" />
                </MenuItem>
                {theTeams.map((team) => (
                  <MenuItem key={team.id} value={team.id}>
                    <Checkbox checked={selectedTeams.indexOf(team.id) > -1} />
                    <ListItemText primary={team.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="ms-auto d-flex gap-3" style={{ marginRight: "20px" }}>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
            <button
              className="btn btn-primary"
              onClick={handleDownloadClick}
              disabled={loading}
            >
              {loading ? (
                "Loading..."
              ) : (
                <CsvDownloader
                  filename="Audit Trail"
                  datas={dataRows}
                  columns={columns.map((col) => ({
                    id: col.field,
                    displayName: col.headerName,
                  }))}
                  separator=","
                  wrapColumnChar={`"`}
                >
                  Download
                </CsvDownloader>
              )}
            </button>

            <button className="btn btn-link" onClick={resetFilters}>
              <i className="bi bi-funnel fs-2 text-dark"></i>
            </button>
          </div>
        </div>

        <CardContent style={{ width: "100%" }}>
          {teamsLoading || auditTicktetWiseReportLoading || localLoading ? (
            <LoadingSpinner />
          ) : (
            <DataGrid
              rows={dataRows}
              columns={columns}
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={handlePaginationChange}
              loading={localLoading}
              disableColumnMenu
              pageSizeOptions={[5, 10, 15, 20]}
              localeText={{
                noRowsLabel: "No rows found",
              }}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "lightgray",
                  "&:last-child": {
                    justifyContent: "flex-end",
                  },
                  whiteSpace: "nowrap", // Prevent wrapping
                  overflow: "hidden", // Hide overflowing text
                  textOverflow: "ellipsis", // Add ellipsis for overflowing text
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                  whiteSpace: "nowrap", // Prevent wrapping
                  overflow: "hidden", // Hide overflowing text
                  textOverflow: "ellipsis", // Add ellipsis for overflowing text
                },
                // Target the pagination select and actions by stable component classes
                "& .MuiTablePagination-select, .MuiTablePagination-actions": {
                  marginBottom: "10px",
                },
                // Target the DataGrid overlay wrapper with its stable class
                "& .MuiDataGrid-overlayWrapper": {
                  height: "50px",
                },
              }}
            />
          )}
        </CardContent>
      </div>
    </div>
  );
};

export default AuditTicktetReport1;